import React, { useContext, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
//import { parseRawData } from '../../parsers';
import _ from 'lodash';
import { deleteEvent, getSummaryData, updatePlan } from 'gqlQueries/promoRecommendation';
import { summaryDataParser } from 'parser/promoRecommendation';
import { UserContext } from 'contexts/ConfigContext';

const errorMessage: string = 'Something went wrong!';

function useFetchSummaryData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const { appConfig } = useContext(UserContext);

    const [fetchSummaryData, { data: eventsListData, loading: eventsListDataLoading, error: eventsListDataError }] =
        useLazyQuery(getSummaryData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPlansSummary } = payload;
            if (getPlansSummary && Array.isArray(getPlansSummary)) {
                const parsedData = summaryDataParser(getPlansSummary, appConfig);
                setData(parsedData);
            }
            //if data present parse it
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setLoading(false);
        setData(null);
        setError(String(error));
    }

    return {
        loading,
        error,
        data,
        fetchSummaryData: (variables: any) => {
            setError(null);
            setLoading(true);
            setData(null);
            fetchSummaryData(variables);
        },
    };
}

export { useFetchSummaryData };
